export const STATUS_TYPE = {
  0: { text: '未审核', color: 'info' },
  1: { text: '审核通过', color: 'success' },
  2: { text: '审核不通过', color: 'danger' },
  '-1': { text: '黑名单', color: 'info' }
};

export const PAGINATION = {
  page: 1,
  size: 25
};
